import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { logger } from '../utils/logger';
import { createPersistMiddleware, PERSIST_VERSION } from './persistMigration';

export interface GlobalState {
  // Planta seleccionada globalmente
  selectedStoreyId: string;
  
  // Elevación global del IFC
  elevationMeters: number;
  elevationType: 'ortometric' | 'ellipsoidal';
  
  // Acciones
  setSelectedStoreyId: (storeyId: string) => void;
  getSelectedStoreyId: () => string;
  setElevation: (meters: number) => void;
  setElevationType: (type: 'ortometric' | 'ellipsoidal') => void;
}

export const useGlobalStore = create<GlobalState>()(
  devtools(
    persist(
      (set, get) => ({
        selectedStoreyId: '',
        elevationMeters: 0,
        elevationType: 'ortometric' as const,
        
        setSelectedStoreyId: (storeyId: string) => {
          logger.log('GLOBAL_STORE', '🔄 GlobalStore: Cambiando planta seleccionada a:', storeyId);
          set({ selectedStoreyId: storeyId });
        },
        
        getSelectedStoreyId: () => {
          return get().selectedStoreyId;
        },
        
        setElevation: (meters: number) => {
          const safe = Number.isFinite(meters) ? meters : 0;
          set({ elevationMeters: safe });
          logger.log('GLOBAL_STORE', `📍 Elevación global establecida: ${safe}`);
        },
        
        setElevationType: (type: 'ortometric' | 'ellipsoidal') => {
          const safeType = type === 'ellipsoidal' ? 'ellipsoidal' : 'ortometric';
          set({ elevationType: safeType });
          logger.log('GLOBAL_STORE', `📍 Tipo de elevación global: ${safeType}`);
        },
      }),
      createPersistMiddleware('global-store', { version: PERSIST_VERSION })
    ),
    {
      name: 'global-store',
    }
  )
);
